$(() => {
  /**
   * jQuery plugin for a Race Roster event store listing.
   * @param options
   * @returns {*}
   */
  $.fn.storeListing = function store(options) {
    const defaults = {
      selectors: {
        productsViewToggle: '.js-products-view-toggle',
        products: '.js-products',
        productsListView: '.store__products--list-view',
        customPrimaryIconColor: '.custom-primary-icon-color',
      },
    };

    /**
     * Switch the products list view between grid and list
     * @param event
     * @param settings
     */
    const toggleProductsListView = (event, settings) => {
      const $this = $(event.currentTarget);

      // don't need do anything if the clicked button is already active
      if ($this.attr('aria-current') === true) {
        return;
      }

      // remove activeness from all the toggles then add activeness to the clicked toggle
      // (doing it this way in case there happens to be a third toggle in the future or something)
      settings.elements.$productsViewToggle.attr('aria-current', false)
        .removeClass(settings.selectors.customPrimaryIconColor.substring(1));

      $this.attr('aria-current', true)
        .addClass(settings.selectors.customPrimaryIconColor.substring(1));

      // if there is a third toggle we'll likely want to use a switch instead
      const view = $this.data('product-view-layout');

      if (view === 'list') {
        settings.elements.$products.addClass(settings.selectors.productsListView.substring(1));
      } else {
        settings.elements.$products.removeClass(settings.selectors.productsListView.substring(1));
      }
    };

    /**
     * Fire up
     */
    const initialize = function initialize() {
      const settings = $.extend(true, {}, defaults, options);
      const $store = $(this);

      settings.elements = {
        $store,
        $productsViewToggle: $store.find(settings.selectors.productsViewToggle),
        $products: $store.find(settings.selectors.products),
      };

      $store
        .on('click', settings.selectors.productsViewToggle, (event) => toggleProductsListView(event, settings));
    };

    return this.each(initialize);
  };
});
